import React from 'react';

// Page-global toast bus: Toast.show(...) anywhere, Toast.Container renders it.
const listeners = new Set();
let counter = 0;

const Toast = {
    show(message, options) {
        options = options || {};
        const toast = { duration: options.duration || 4000, id: ++counter, message };
        listeners.forEach((notify) => notify(toast));
    },
    subscribe(listener) {
        listeners.add(listener);
        return () => { listeners.delete(listener); };
    }
};

function Container() {
    const [toasts, setToasts] = React.useState([]);
    const dismiss = React.useCallback((id) => {
        setToasts((current) => current.filter((t) => t.id != id));
    }, []);
    React.useEffect(() => {
        return Toast.subscribe((toast) => {
            setToasts((current) => [...current, toast]);
            setTimeout(() => dismiss(toast.id), toast.duration);
        });
    }, [dismiss]);
    if (toasts.length == 0) {
        return null;
    }
    return (
        <div className="ol__toasts">
            {toasts.map((toast) => (
                <div className="ol__toast" key={toast.id} onClick={() => dismiss(toast.id)}>
                    {toast.message}
                </div>
            ))}
        </div>
    );
}
Toast.Container = Container;

export default Toast;
